// extracted by mini-css-extract-plugin
export default {"wrapper":"Slide_wrapper__aIZUg","container":"Slide_container__9vdq3"};